import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";

/**
 * Generated class for the AddorderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
	selector: "page-settlement",
	templateUrl: "settlement.html"
})
export class SettlementPage {
	constructor(public navCtrl: NavController, public navParams: NavParams) {}

	ionViewDidLoad() {
		console.log("ionViewDidLoad SettlementPage");
	}
}



// WEBPACK FOOTER //
// ./src/pages/settlement/settlement.ts